var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#232323"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.875 10.25a3.333 3.333 0 1 1 3.333-3.333 3.337 3.337 0 0 1-3.333 3.333zm0-5.167a1.833 1.833 0 1 0 1.833 1.834 1.835 1.835 0 0 0-1.833-1.834z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.63 15.42H3.88a2.633 2.633 0 0 1-2.63-2.63v-.17a3.875 3.875 0 0 1 3.87-3.87h.75a.75.75 0 0 1 0 1.5h-.75a2.373 2.373 0 0 0-2.37 2.37v.17a1.131 1.131 0 0 0 1.13 1.13h2.75a.75.75 0 0 1 0 1.5zM18.125 10.25a3.333 3.333 0 1 1 3.333-3.333 3.337 3.337 0 0 1-3.333 3.333zm0-5.167a1.833 1.833 0 1 0 1.833 1.834 1.835 1.835 0 0 0-1.833-1.834z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.13 15.42h-2.76a.75.75 0 0 1 0-1.5h2.76a1.126 1.126 0 0 0 1.12-1.13v-.17a2.373 2.373 0 0 0-2.37-2.37h-.75a.75.75 0 0 1 0-1.5h.75a3.875 3.875 0 0 1 3.87 3.87v.17a2.628 2.628 0 0 1-2.62 2.63z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#232323"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12 14.083a3.417 3.417 0 1 1 3.417-3.416A3.42 3.42 0 0 1 12 14.083zm0-5.333a1.917 1.917 0 1 0 1.917 1.917A1.92 1.92 0 0 0 12 8.75z",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M14 20.75h-4A2.753 2.753 0 0 1 7.25 18v-.667a4.75 4.75 0 0 1 9.5 0V18A2.753 2.753 0 0 1 14 20.75zm-2-6.667a3.254 3.254 0 0 0-3.25 3.25V18A1.251 1.251 0 0 0 10 19.25h4A1.251 1.251 0 0 0 15.25 18v-.667a3.254 3.254 0 0 0-3.25-3.25z",
    opacity: 1,
    "data-original": "#7fbde7",
    className: ""
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.7a6104405b06898a9bc178befcc1d8ce.svg";
export { ForwardRef as ReactComponent };